<template>
  <div class="col-lg-3 p-0 m-0">
    <div class="image">
      <div class="image-inner">
        <router-link :to="{ name: 'Product', params: { slug: product.slug }}">
          <img :src="product.logo.slug | media({width: 200, crop: 'box'})" :alt="`Logo ${product.name}`">
        </router-link>
      </div>
      <div class="image-info">
        <h5 class="title">{{ product.name }}</h5>
        <div class="author">
          <!-- <small>by</small> <span class="text-success"><a :href="product.externalLinkDist">
{{ product.author.nickname }}</a>
</span> -->
          <small>by</small> <span class="text-success">{{ product.author.nickname }}</span>
        </div>        
        <div class="desc text-muted">
          {{ product.certifications | certifications }}
        </div>
        <hr class="m-0 p-0">
        <rating :rate="product.stats.rate" class="pull-left m-t-10"></rating>
        <div class="price pull-right">
          <h4>
            <span class="label label-success">Free</span>
          </h4>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Rating from '@/components/Rating'

export default {
  name: 'AppCard',
  props: ['product'],
  components: { rating: Rating }
}
</script>




// WEBPACK FOOTER //
// src/components/AppCard.vue